import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";

//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

export const SmeSlice = createSlice({
 name: "Nominationlist",
 initialState: {
  error: false,
  trainingSkills: [],
  trainingList: [],
  courseWiseList: [],
  approvedCountSME: 0,
  rejectedCountSME: 0,
  nominatedCountSME: 0,
  isSMEUSerPresent: false,
  isLoader: false,
  isDataSentSuccess: false,
  isDataSentFailure:false,
 },
 reducers: {
  setTrainingSkills: (state, { payload }) => {
   state.error = false;
   state.trainingSkills = payload;
  },
  setError: (state) => {
   state.error = true;
  },
  setTrainingList: (state, { payload }) => {
   state.error = false;
   state.trainingList = payload;
  },
  updateStatus: (state, { payload }) => {
   state.error = false;
   state.trainingSkills.map((val, i) => {
    if (val.id == payload.id) {
     val.status = payload.status;
    }
   });
  },
  setFilteredList: (state, { payload }) => {
   state.error = false;
   // let updatedData = state.trainingSkills.filter((item) => item.status === payload);
   state.trainingSkills = payload;
  },
  setCourseWiseList: (state, { payload }) => {
   state.error = false;
   state.courseWiseList = payload;
  },
  setSubmitStatus: (state, { payload }) => {
   state.error = false;
   state.courseWiseList.map((val, i) => {
    if (val.id == payload.id) {
     val.status = payload.status;
     val.reason = payload.reason;
    }
   });
   let updatedObjects = state.courseWiseList.filter((item) => item.status == 1);
   state.courseWiseList = updatedObjects;
  },

  setNominatedCountSME: (state, { payload }) => {
   state.nominatedCountSME = payload[0].nominationCount;
  },
  setLoader: (state, { payload }) => {
   state.isLoader = true;
   state.isDataSentSuccess = false;
   state.isDataSentFailure = false;
  },
  setDataSentSuccess: (state) =>{
    state.isLoader = false;
    state.isDataSentSuccess = true;
    state.isDataSentFailure = false;
  },
  setDataSentFailure: (state) =>{
    state.isLoader = false;
    state.isDataSentSuccess = false;
    state.isDataSentFailure = true;
  },
  setCountSME: (state, { payload }) => {
   state.rejectedCountSME = 0;
   state.approvedCountSME = 0;

   payload.result.map((val, i) => {
    if (val.status == "3") {
     state.rejectedCountSME = val.count;
    } else if (val.status == "2") {
     state.approvedCountSME = val.count;
    }
   });

   payload.result1.map((val, i) => {
    if (val.prevStatus == "2") {
     state.approvedCountSME += val.prev_count;
    }
   });
  },
  setUpdateCountSME: (state, { payload }) => {
   if (payload.status == 2) {
    state.approvedCountSME += payload.count;
   } else if (payload.status == 3) {
    state.rejectedCountSME += payload.count;
   }
  },
  setSMEUser: (state, { payload }) => {
   console.log("payload", payload);
   if (payload > 0) {
    state.isSMEUSerPresent = true;
   }
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setTrainingSkills,
 setError,
 setTrainingList,
 updateStatus,
 setFilteredList,
 setCourseWiseList,
 setSubmitStatus,
 setNominatedCountSME,
 setCountSME,
 setUpdateCountSME,
 setSMEUser,
 setLoader,
 setDataSentSuccess,
 setDataSentFailure
} = SmeSlice.actions;

export default SmeSlice.reducer;

export function getNominationListBasedOnSkills(course) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchNominationSkills/${course}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    dispatch(setTrainingSkills(res.data));
    console.log("res from getnomination list based on skills", res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function getNominationList() {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchTrainingList`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    dispatch(setTrainingList(res.data));
    //dispatch(setCourseWiseList(res.data));
    console.log("res from get nomination list", res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function smeAction(id, status, reason, course, date) {
 console.log("jj", id, status);
 return (dispatch) => {
  console.log(reason, "reason");
  Axios.post(
   `${baseURL}/updatingAction`,
   {
    id,
    status,
    reason,
   },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setSubmitStatus({ id, status, reason }));
    dispatch(getFilterNominationList(course, date));
   })
   .catch((err) => {
    // then print response status
    console.error("error is", err);
   });
 };
}

export function getFilterNominationList(course, date) {
 return (dispatch) => {
  dispatch(setLoader());
  Axios.post(
   `${baseURL}/fetchSMEfilteredNominationList`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    //dispatch(setFilteredList(res.data));
    dispatch(setCourseWiseList(res.data));
    dispatch(setDataSentSuccess());
    
    console.log("res from get filtered nomination list", res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    dispatch(setDataSentFailure());
    console.error("error is", err);
   });
 };
}

export function fetchUserListByCourse(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchuserlistbycourse`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    console.log("res in coursewiselist", res.data);
    dispatch(setCourseWiseList(res.data));
    // setTrainingList(res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function fetchWaitingForApprovalList(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchWaitingForApprovalList`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    console.log("res in coursewiselist", res.data);
    // dispatch(setCourseWiseList(res.data));
    // setTrainingList(res.data);
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function getNominatedCountSME(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getnominatedcount`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setNominatedCountSME(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function updateCountSME(status,count) {
 return (dispatch) => {
  dispatch(setUpdateCountSME({ status,count }));
 };
}
export function getCountSME(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getcount`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setCountSME(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function checkUserPresent(username, accessToken) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/checkUserPresent`,
   { username },
   {
    headers: {
     Authorization: accessToken,
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setSMEUser(res.data[0].name_count));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
